import { toast } from '../../hooks/use-toast';

// Keep localized Settings feedback scoped to this surface.
export const settingsNotifications = (language) => ({
  showSuccess: (message, locale = language) => toast({
    title: locale === 'es' ? 'Éxito' : 'Success',
    description: message,
    duration: 5000,
    className: 'bg-green-50 border-green-200',
  }),
  showError: (message) => toast({
    title: 'Error',
    description: message,
    duration: 5000,
    variant: 'destructive',
  }),
});
